import { useMemo } from 'react';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import { useSelector } from 'react-redux';
import PATHS from 'lib/navigation/paths';
import { useTranslation } from 'next-i18next';

const useGetTermsAndConditionsTabs = () => {
  const showMembership = useSelector(
    (state) => state.globalData.showMembership,
  );

  const { t } = useTranslation('fe_er_rental_terms_and_conditions_page');

  const tabs = useMemo(() => {
    if (!showMembership) {
      return [
        {
          label: t('fe_er_common_rentals_tab_bar:rental'),
          value: 1,
          href: PATHS.rentals.rentalTerms(),
          component: NavigatorLink,
        },
        {
          label: t('fe_er_common_rentals_tab_bar:self_tours_conditions'),
          value: 2,
          href: PATHS.tour.selfDriveTourTerms(),
          component: NavigatorLink,
        },
        {
          label: t('fe_er_common_rentals_tab_bar:guided_tours_tc'),
          value: 3,
          href: PATHS.tour.guidedTourTerms(),
          component: NavigatorLink,
        },
        {
          label: t('fe_er_common_rentals_tab_bar:gift_cards_tc'),
          value: 4,
          href: PATHS.rentals.terms(),
          component: NavigatorLink,
        },
        {
          label: t('fe_er_common_rentals_tab_bar:Rewards_tc'),
          value: 5,
          href: PATHS.rewardsTermsAndConditions(),
          component: NavigatorLink,
        },
        {
          label: t('fe_er_common_rentals_tab_bar:off_road_tours'),
          value: 6,
          href: PATHS.tour.offRoadTourTerms(),
          component: NavigatorLink,
        },
      ];
    }
    return [
      {
        label: t('fe_er_common_rentals_tab_bar:rental'),
        value: 1,
        href: PATHS.rentals.rentalTerms(),
        component: NavigatorLink,
      },
      {
        label: t('fe_er_common_rentals_tab_bar:self_tours_conditions'),
        value: 2,
        href: PATHS.tour.selfDriveTourTerms(),
        component: NavigatorLink,
      },
      {
        label: t('fe_er_common_rentals_tab_bar:guided_tours_tc'),
        value: 3,
        href: PATHS.tour.guidedTourTerms(),
        component: NavigatorLink,
      },
      {
        label: t('fe_er_common_rentals_tab_bar:membership_tc'),
        value: 4,
        href: PATHS.membership.termsAndConditions(),
        component: NavigatorLink,
      },
      {
        label: t('fe_er_common_rentals_tab_bar:gift_cards_tc'),
        value: 5,
        href: PATHS.rentals.terms(),
        component: NavigatorLink,
      },
      {
        label: t('fe_er_common_rentals_tab_bar:Rewards_tc'),
        value: 6,
        href: PATHS.rewardsTermsAndConditions(),
        component: NavigatorLink,
      },
      {
        label: t('fe_er_common_rentals_tab_bar:off_road_tours'),
        value: 7,
        href: PATHS.tour.offRoadTourTerms(),
        component: NavigatorLink,
      },
    ];
  }, [showMembership]);

  return { tabs };
};

export default useGetTermsAndConditionsTabs;
